import { Component, Inject, OnInit, Input } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';

@Component({
  selector: 'app-sku-price-history',
  imports: [RmsModule],
  templateUrl: './sku-price-history.component.html',
  styleUrl: './sku-price-history.component.scss'
})
export class SkuPriceHistoryComponent implements OnInit {
  @Input() CoffeeName: string = '';
  @Input() HistoricalPrices: any[] = [];
  columns: Column[] = [
    { label: 'Price Date', key: 'PriceDate', type: 'date' },
    { label: 'Ask Price Fixed', key: 'AskPriceFixed' },
    { label: 'Ask Price Diff', key: 'AskPriceDiff' },
    { label: 'Replacement Fixed', key: 'ReplacementFixed' },
    { label: 'Replacement Diff', key: 'ReplacementDiff' },
    { label: 'Current Market Price', key: 'CurrentMarketPrice' },
    { label: 'Comments', key: 'Comments' }
  ];

  ngOnInit(): void {
    console.log('HistoricalPrices:', this.HistoricalPrices);
  }
}
